/**
 * 개인정보 동의 — 두 법인(중앙산업·경원산업) 계정 정보 공동 이용 (2026-10-23 사용자 결정).
 *
 * 계정 한 벌을 두 법인이 함께 쓰므로 법 제17조 제1항 제1호(동의)를 근거로 둔다.
 * 가입 화면에서 받고 users/{uid}.consents.joint_use = { version, agreed_at } 로 기록한다.
 * 관리자가 만든 계정·기존 계정은 서면 동의서(docs/policies/개인정보_내부관리계획.md 부록)로 받는다.
 * 문구가 바뀌면 version 을 올리고 개인정보처리방침 4장도 함께 고친다.
 */
export const JOINT_USE_CONSENT_VERSION = "2026-09-01";

/** 동의 화면에 보이는 고지 항목(법 제17조 제2항). */
export const JOINT_USE_CONSENT_NOTICE: ReadonlyArray<readonly [string, string]> = [
  ["제공받는 자", "중앙산업(주) ↔ 경원산업(주)"],
  ["목적", "ERP 계정 공동 사용, 두 법인 업무 권한 부여"],
  ["항목", "이름, 아이디, 휴대폰 번호, 이메일, 소속·권한"],
  ["보유 기간", "퇴직 후 1년(계정 삭제 시까지)"],
  ["거부 권리", "동의하지 않을 수 있으나, ERP 계정은 두 법인이 함께 관리하므로 가입할 수 없습니다"],
];

/**
 * ERP 이용 규정(web/public/terms.html) 동의 — 가입 1단계 [필수] (2026-10-26).
 * users/{uid}.consents.terms = { version, agreed_at }. 규정 부칙의 시행일이 바뀌면 version 도 올린다.
 */
export const TERMS_CONSENT_VERSION = "2026-09-01";

/**
 * 개인정보 수집·이용 안내 — 가입 1단계 [필수] 확인 체크 (2026-10-26 사용자 요청으로 체크 필수화).
 * 계정 정보의 처리 근거는 동의가 아니라 근로계약 이행(법 제15조 제1항 제4호)이라
 * 문구는 "동의"가 아니라 "확인"으로 받는다 — 처리방침 2장의 근거와 어긋나지 않게.
 * users/{uid}.consents.privacy_notice = { version, agreed_at }. 처리방침 2·5·9장과 같은 내용을 유지한다.
 */
export const PRIVACY_NOTICE_VERSION = "2026-09-01";

export const ACCOUNT_PRIVACY_NOTICE: ReadonlyArray<readonly [string, string]> = [
  ["항목", "아이디, 비밀번호(암호화), 이름, 휴대폰 번호, 이메일, 생년월일"],
  ["수집 방법", "회원가입 화면, 관리자 등록"],
  ["목적", "ERP 계정 발급·본인 확인, 업무 권한 관리, 업무 연락"],
  ["근거", "근로계약 이행(법 제15조 제1항 제4호)"],
  ["보유 기간", "퇴직 시 즉시 정지, 퇴직 후 1년이 지나면 삭제"],
  ["처리 위탁", "Google LLC(Google Cloud·Firebase) — 서버·데이터베이스·로그인 인증 운영"],
  ["정보주체 권리", "언제든지 열람, 정정·삭제, 처리정지를 요구할 수 있습니다(법 제35조~제37조)"],
];
